export default __webpack_public_path__ + "static/media/manzana.fed788aa.png";